// extracted by mini-css-extract-plugin
export default {"news_holder":"HomeNews_news_holder__Q3V6u","button_holder":"HomeNews_button_holder__tkS+0","main_title":"HomeNews_main_title__tT4UD"};